import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X, Instagram } from "lucide-react";
import { useCart } from "@/context/CartContext";

const NAV = [
  { to: "/shop", label: "Shop" },
  { to: "/shop?collection=876 Series", label: "Drops" },
  { to: "/track", label: "Track Order" },
];

const MOBILE_NAV = [
  { to: "/shop", label: "Shop" },
  { to: "/shop?collection=876 Series", label: "Drops" },
  { to: "/about", label: "About" },
  { to: "/track", label: "Track Order" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-and-conditions", label: "Terms & Conditions" },
  { to: "/refund-policy", label: "Refund & Exchange" },
];

export function Header() {
  const { count, setDrawerOpen } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-black/85 backdrop-blur-md border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <img src="/brand/logo-horizontal.webp" alt="Turahtid — True to the Culture" data-testid="header-logo" className="h-11 sm:h-12 w-auto rounded-sm" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.label}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs uppercase tracking-widest transition-colors text-zinc-300 hover:text-jamaica-gold"
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://instagram.com/turahtid"
            target="_blank"
            rel="noreferrer"
            data-testid="header-instagram"
            aria-label="Follow @turahtid on Instagram"
            className="hidden sm:flex items-center gap-1.5 p-2 text-zinc-300 hover:text-jamaica-gold transition-colors"
          >
            <Instagram className="w-5 h-5" />
            <span className="font-mono text-[11px] uppercase tracking-widest">@turahtid</span>
          </a>
          <button
            data-testid="cart-button"
            onClick={() => setDrawerOpen(true)}
            className="relative p-2 hover:text-jamaica-gold transition-colors"
          >
            <ShoppingBag className="w-5 h-5" />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-0.5 -right-0.5 bg-jamaica-gold text-black text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 px-4 py-4 flex flex-col gap-4">
          {MOBILE_NAV.map((n) => (
            <Link
              key={n.label}
              to={n.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-sm uppercase tracking-widest text-zinc-300 hover:text-jamaica-gold"
            >
              {n.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
